export default __webpack_public_path__ + "static/media/top2.13386bff.svg";